import PerfectScrollbar from 'perfect-scrollbar';
import { Component,OnInit, Inject } from '@angular/core';
import {BaseComponent} from '../shared/core/base.component'
import {AuthenticationService} from '../services/authentication.service'
import {ProfileService} from '../services/profile.service';
import {DashboardService} from '../services/dashboard.service';
import { DOCUMENT } from '@angular/common';
declare const $: any;

const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
        path: '/dashboard',
        title: 'Dashboard',
        type: 'link',
        icontype: 'dashboard'
    },
    {
        path: '/tenants/list',
        title: 'Tenants',
        type: 'link',
        icontype: 'apps'
    },
    {
        path: '/viewer',
        title: 'HTML5 Viewer',
        type: 'sub',
        icontype: 'view_compact',
        collapse: 'viewer',
        children: [
            {path: 'viewerconfig', title: 'Config', ab:'VC'}
        ]
    },
    {
        path: '/fillableforms',
        title: 'Fillable Forms',
        type: 'sub',
        icontype: 'dynamic_form',
        collapse: 'forms',
        children: [
            //{path: 'formsconfig', title: 'Forms Config', ab:'FC'},
            {path: 'formsdesign', title: 'List', ab:'FL'},
            {path: 'formsconfig', title: 'UI Config', ab:'UI'},
        ]
    }
    ,
    {
        path: '/reportforms',
        title: 'Report Forms',
        type: 'sub',
        icontype: 'file_present',
        collapse: 'list',
        children: [
            {path: 'list', title: 'List', ab:'RL'},
        ]
    }
    
];
@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent extends BaseComponent implements OnInit {
    clientName:string;
    public menuItems: any[];
    userGuideURL:string;
    installGuideURL:string;
    ps: any;
    isMini: boolean = false;
       isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };
    constructor(@Inject(DOCUMENT) private document: any,  authenticationService:AuthenticationService,private dashboardService:DashboardService,private profileService:ProfileService ) {
        super(authenticationService);
    }

    minimizeSidebar(){
        const body = document.getElementsByTagName('body')[0];

        if (misc.sidebar_mini_active === true) {
            body.classList.remove('sidebar-mini');
            misc.sidebar_mini_active = false;
            this.isMini = false;
        } else {
            setTimeout(() => {
                body.classList.add('sidebar-mini');
                misc.sidebar_mini_active = true;
                this.isMini = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function() {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function() {
            clearInterval(simulateWindowResize);
        }, 1000);
      }
      hideSidebar(){
        const body = document.getElementsByTagName('body')[0];
        const sidebar = document.getElementsByClassName('sidebar')[0];
  
        if (misc.hide_sidebar_active === true) {
            setTimeout(function() {
                body.classList.remove('hide-sidebar');
                misc.hide_sidebar_active = false;
            }, 300);
            setTimeout(function () {
                sidebar.classList.remove('animation');
            }, 600);
            sidebar.classList.add('animation');
  
        } else {
            setTimeout(function() {
              body.classList.add('hide-sidebar');
                // $('.sidebar').addClass('animation');
                misc.hide_sidebar_active = true;
            }, 300);
        }
  
        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function() {
            window.dispatchEvent(new Event('resize'));
        }, 180);
  
        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function() {
            clearInterval(simulateWindowResize);
        }, 1000);
      }

    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }
        this.clientName=this.getClientName();
        this.userGuideURL = this.document.location.origin + "/docs/VectorViewer-UserGuide.html";
        this.installGuideURL = this.document.location.origin + "/docs/VectorViewer-InstallationGuide.html";

    }
    isMenuEnabled(path)
    {
        return this.authenticationService.isModuleEnabled(path);
    }
    updatePS(): void  {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
    logout()
    {
        this.authenticationService.logout()
                .subscribe(result => {
                    this.dashboardService.clearCache();
                    this.profileService.clearCache();
                    this.redirectToLogin();
                    });
    }
    changepassword()
    {
        this.authenticationService.changePassword()
                .subscribe(result => {
                    this.showMessage("success","Email sent with instructions to reset your password");
                    });
    }
}
